import React, { useMemo } from 'react';
import './index.less';

const HeaderLeftContent: React.FC<{ userInfo: any }> = ({ userInfo }) => {
  const logoSrc = useMemo(() => {
    if (userInfo?.companyId === '202504141531150003228424') {
      return '//fx-pangu.oss-cn-hangzhou.aliyuncs.com/logo/carpdance/zhongguoshiyou-logo.png';
    }
    if (userInfo?.companyId === '202504141152220002927460') {
      return '//fx-pangu.oss-cn-hangzhou.aliyuncs.com/logo/carpdance/bingtuanhong-logo.png';
    }

    return '//oss.elebuys.com/cdn/9/image/1776220476973_6540f96b.png';
  }, [userInfo?.companyId]);

  if (!userInfo?.companyId) return '';

  return (
    <div className="fle-layout-header-left-content">
      <div className="fle-layout-header-logo">
        <img src={logoSrc} alt="logo" style={ logoSrc.includes('zhongguoshiyou') ? {transform: 'translateX(-10px) scale(1.5)'} : {}} />
      </div>
    </div>
  );
};
export default React.memo(HeaderLeftContent);
